export function parsePositiveIdList(value: string | null): number[] {
	if (!value) return [];

	const seen = new Set<number>();
	return value.split(',').reduce<number[]>((ids, part) => {
		const trimmed = part.trim();
		if (!/^\d+$/.test(trimmed)) return ids;
		const id = Number(trimmed);
		if (!Number.isSafeInteger(id) || id <= 0 || seen.has(id)) return ids;
		seen.add(id);
		ids.push(id);
		return ids;
	}, []);
}
